import { PropsWithChildren } from "react"
import { NarrowLayout } from "source/Layout"

export default function ConfirmationLayout({ children }: PropsWithChildren) {
  return (
    <NarrowLayout>
      <div className="login-form--narrow pt-3@iframe pb-3@iframe">
        {children}
      </div>
    </NarrowLayout>
  )
}
